import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppMixin extends Vue {
  get app() {
    return this.$store.appModule;
  }
}
